import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Confirm } from 'semantic-ui-react';
import i18next from 'i18next';
import { hideConfirm } from '../../actions';

class MyConfirm extends Component {
    render() {
        const { onConfirm, title, message, deletedName } = this.props.confirm || {};

        return (
            <Confirm
                style={{ direction: i18next.dir() }}
                confirmButton={i18next.t('yes')}
                cancelButton={i18next.t('no')}
                open={Boolean(this.props.confirm)}
                header={title || null}
                content={deletedName ? i18next.t('deleteMessage', { name: deletedName }) : message}
                onCancel={this.props.hideConfirm}
                onConfirm={() => {
                    onConfirm();
                    this.props.hideConfirm();
                }}
            />
        );
    }
}

MyConfirm.propTypes = {
    hideConfirm: PropTypes.func,
    confirm: PropTypes.object,
};

const mapStateToProps = (state) => {
    const { confirm } = state;

    return { confirm };
};

export default connect(mapStateToProps, { hideConfirm })(MyConfirm);
